import React from 'react';
import styled from '@emotion/styled';
import {
  useAiFirmSetting,
  useUpdateAiFirmSetting,
} from 'hooks/ai-firm-settings-hooks';

const Info = styled.div`
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 0.95em;
  line-height: normal;
`;

export default function AiFirmSetting() {
  const { data: aiFeaturesSetting, isLoading } = useAiFirmSetting();
  const updateMutation = useUpdateAiFirmSetting();

  const handleToggleAiSetting = () => {
    updateMutation.mutate(!aiFeaturesSetting);
  };

  return (
    <>
      {isLoading ? <div id="loading" /> : null}

      <div className="center-wrapper">
        <h2>AI Features</h2>
        <div style={{ color: '#7d7d7e' }}>
          Control access to AI-powered features for your organization including
          message compose assistance, file tagging suggestions, AI-powered
          search, and review workflow enhancements.
        </div>

        <div className="mfa-card mt-4">
          <div className="d-flex align-items-center mb-3">
            <div className="toggle-container mr-2">
              <input
                type="checkbox"
                className="toggle"
                checked={!!aiFeaturesSetting}
                onChange={handleToggleAiSetting}
              />
            </div>

            <div className="mfa-title">Enable AI Features</div>

            {aiFeaturesSetting && (
              <div className="green-badge ml-auto">ENABLED</div>
            )}
          </div>

          {!aiFeaturesSetting && (
            <Info style={{ backgroundColor: '#E6F7FB' }}>
              Enabling AI features will provide your firm with access to
              AI-powered functionality including message compose assistance,
              file tagging and renaming suggestions, enhanced search
              capabilities, and workflow improvements. All users in your firm
              will have access to these features immediately.
            </Info>
          )}

          {aiFeaturesSetting && (
            <Info style={{ backgroundColor: '#F5F3B4' }}>
              AI features are currently enabled for your firm. Users can access
              AI-powered tools throughout the platform. Disabling this setting
              will immediately remove access to AI features for all users.
            </Info>
          )}

          {aiFeaturesSetting && (
            <div
              style={{ marginTop: '15px', fontSize: '0.9em', color: '#666' }}
            >
              <strong>AI Features Include:</strong>
              <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                <li>Message compose assistance</li>
                <li>File tagging suggestions</li>
                <li>File renaming suggestions</li>
                <li>AI-powered search</li>
                <li>Review workflow enhancements</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
